const DialogueType = {
  Q_AND_A: 'Q_AND_A',
  COMMANDS: 'COMMANDS',
  UNSOLICITED: 'UNSOLICITED',
  NPC_Q_AND_A: 'NPC_Q_AND_A',
  NPC_COMMANDS: 'NPC_COMMANDS',
  NPC_UNSOLICITED_DIALOGUE: 'NPC_UNSOLICITED_DIALOGUE',
  AI_PATIENT_PROMPT: 'AI_PATIENT_PROMPT',
  AI_DIRECTED_DIALOGUE: 'AI_DIRECTED_DIALOGUE',
  AI_NPC_PROMPT: 'AI_NPC_PROMPT',
  AI_NPC_DIALOGUE: 'AI_NPC_DIALOGUE',
};

export default DialogueType;